<template>
    <gofix-card title="" class="pt-4" classContent="mb-2">
        <b-row>
            <b-col md="3">
                <b-row>
                    <b-col md="6">
                        <gofix-form-dropdown
                            label="Month"
                            :clearable="false"
                            :filterable="false"  
                            fullContent
                            :searchable="false"
                            :options="months"
                            vLabel="text"
                            :reduce="option => option.value"
                            v-model="month">
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-dropdown
                            label="Year"
                            :clearable="false"
                            :filterable="false" 
                            :searchable="false"
                            :options="years"
                            v-model="year">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>
            </b-col>
            <b-col md="5">
                <b-row>
                    <b-col md="6">
                        <gofix-form-dropdown
                            v-bind:class="{'run-loading small-loading': loading}"
                            label="Supplier Contract"
                            vLabel="contract_title"
                            :reduce="option => option['id']"
                            @search="searchSupplierContract"
                            :filterable="false"
                            v-model="header.data.supplier_contract"
                            :options="header.options.supplier_contracts">
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-dropdown
                            v-bind:class="{'run-loading small-loading': loading}"
                            label="Maintenance Type"
                            vLabel="description_one"
                            :clearable="false"
                            :filterable="false"
                            @search="searchMaintenanceType"
                            v-model="header.data.maintenance_id"
                            :options="header.options.maintenance_ids">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>
            </b-col>
            <b-col md="4">
                <b-row>
                    <b-col md="5"> </b-col>
                    <b-col md="7" class="text-center pt-15">
                        <div class="d-flex">
                            <!-- <gofix-button class="mr-10" label="Preview" @click="previewEntry"></gofix-button> -->
                            <!-- <gofix-button label="Compute" @click="saveEntry" v-if="activeSaveBtn == true"></gofix-button> -->
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <hr class="mt-0 border-width-2px"/>
        <b-collapse visible :id="`collapse-` + index">
            <gofix-table :settings="tableConfig"
                :table-items="tableItems"
                @new-item="openModalItem"
                @load-items="getTableData"
                @delete-items="deleteItems"
                ref="gofixTable">
                <template slot="gofix_table:average_score" slot-scope="row">
                    {{ row.item.average_score !== null ? row.item.average_score : 0 | formatMoney(2, '') }}
                </template>
                <template slot="gofix_table:max_score" slot-scope="row">
                    {{ row.item.max_score !== null ? row.item.max_score : 0 | formatMoney(2, '') }}
                </template>
                <template slot="gofix_table:bottom-row" slot-scope="row" v-if="tableItems.length">
                    <td class="text-right" :key="i" v-for="(field, i) in row.data.fields">
                        <div class="total-header" v-if="field.key === 'property_name'">
                            <p class="mb-1 text-left">
                                <strong>Total</strong>
                            </p>
                        </div>
                        <div v-if="field.key === 'no_of_inspection'">
                            <p class="mb-1">{{ total_no_of_inspection }}</p>
                        </div>
                        <div v-if="field.key === 'average_score'">
                            <p class="mb-1">{{ total_average_score | formatMoney(2, '') }}</p>
                        </div>
                        <div v-if="field.key === 'max_score'">
                            <p class="mb-1">{{ total_max_score | formatMoney(2, '') }}</p>
                        </div>
                    </td>
                </template>
            </gofix-table>
        </b-collapse>
    </gofix-card>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
    name: 'po_component_section',
    props: {
        index: { type: Number, default: 0 }
    },
    data() {
        return {
            loading:false,
            tableConfig:{
                name: 'performance-assesment-contract-sum',
                controls:{
                    create: false,
                    update: false,
                    delete: false,
                    tableImport: false,
                    tableExport: false,
                    tableColumnSettings: false,
                    reload: false,
                    tablePagination: false,
                    tableFilter: false
                },
                filter: { },
                page: 1,
                limit: 100,
                total: 0,
                useDatabaseView: true,
                sortColumn: 'sor_code',
                sortDirection: 'asc',
                fields: [
                    {
                        key: 'property_name',
                        label: 'Division',
                        isActive: 1,
                        isFilter: false,
                        thStyle: '',
                        sorting: false,
                        thClass: 'text-left',
                        tdClass: 'text-left'
                    },
                    {
                        key: 'officer_name',
                        label: 'Officer',
                        isActive: 1,
                        isFilter: false,
                        thStyle: '',
                        sorting: false,
                        thClass: 'text-left',
                        tdClass: 'text-left'
                    },
                    {
                        key: 'no_of_inspection',
                        label: 'No. of Inspection',
                        isActive: 1,
                        isFilter: false,
                        thStyle: '',
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                    {
                        key: 'average_score',
                        label: 'Average Score',
                        isActive: 1,
                        isFilter: false,
                        thStyle: '',
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                    {
                        key: 'max_score',
                        label: 'Max Score',
                        isActive: 1,
                        isFilter: false,
                        thStyle: '',
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                    {
                        key: 'auto',
                        label: '',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                ]
            },
            tableItems: [],
            supplier_contracts: [],
            maintenance_ids: [],
            modal: {
                title: '',
                open: false,
                loading: false,
                options: {
                    assessment_types: ['Inspection by Property Officers', 'Maintenance Regime', 'Other sources']
                },
                data: {
                    contract_id: null,
                    assessment_type: null,
                    weightage: null
                }
            },
            header: {
                options: {
                    maintenance_ids: [],
                    supplier_contracts: []
                },
                data: {
                    supplier_contract: null,
                    maintenance_id: null,
                    maintenance_ids: null,
                    supplier_contract: null
                }
            },
            years: [],
            year: '',
            months: [],
            month: '',
            loadingData: false,
            activeSaveBtn: false,
            itemsPreview: '',
            total_no_of_inspection: 0,
            total_average_score: 0,
            total_max_score: 0,
            timer: {
                maint: null,
                save: null
            },
        }
    },
    watch: {
        ClientContractID: function(val) {
            this.tableItems = []
            this.getSupplierContract()  
        },
        'header.data.supplier_contract': function(val) {
            this.header.data.maintenance_id = null
            this.header.options.maintenance_ids = []
            this.tableItems = []
            this.getMaintenanceType()

            if ( val && this.$refs.gofixTable) {
                this.$refs.gofixTable.reloadTableItems()
            }
        },
        'header.data.maintenance_id': function(val) {
            this.tableItems = []
            if ( val && this.$refs.gofixTable) {
                this.$refs.gofixTable.reloadTableItems()
            }
        },
        'year': function(val) {
            this.tableItems = []
            if ( val && this.$refs.gofixTable) {
                this.$refs.gofixTable.reloadTableItems()
            }
        },
        'month': function(val) {
            this.tableItems = []
            if ( val && this.$refs.gofixTable) {
                this.$refs.gofixTable.reloadTableItems()
            }
        },
        tableItems: function(items) {

            this.total_no_of_inspection = 0
            this.total_average_score = 0
            this.total_max_score = 0
            
            const that = this;
            if ( items.lenght !== 0 ) {
                items.map(item => {
                    if ( item.no_of_inspection ) {
                        that.total_no_of_inspection = that.total_no_of_inspection + Number(item.no_of_inspection)
                    }
                    if ( item.average_score ) {
                        that.total_average_score = that.total_average_score + Number(item.average_score)
                    }
                    if ( item.max_score ) {
                        that.total_max_score = that.total_max_score + Number(item.max_score)
                    }
                })
            }
        },
    },
    computed: {
        ...mapGetters({
            ClientContractID: 'ContractController/ClientContractID'
        })
    },
    created() {
        this.getInitData()

        let item = localStorage.getItem("ClientContractID");
        if(item) item = JSON.parse(item);

        if(
            (this.ClientContractID && this.ClientContractID.id && item) || (!this.ClientContractID || !this.ClientContractID.id) && !item
        ) this.getSupplierContract()
    },
    methods: {
        async getTableData(callback) {
            const { tableRequest , resolve,reject } = await callback();

            this.activeSaveBtn = false
            if ( !this.header.data.supplier_contract || !this.header.data.maintenance_id ) {
                const response = {
                    items: [],
                    total: 0
                }
                resolve(response);
                this.tableItems = response.items;
                this.tableConfig.total = response.total;
                return;
            }
            
            tableRequest.filter.month = this.month
            tableRequest.filter.year = this.year
            tableRequest.filter.contract_id = this.header.data.supplier_contract
            tableRequest.filter.maintenance_id = this.header.data.maintenance_id.id
            tableRequest.limit = 100
            tableRequest.page = 1
            tableRequest.isCMS = false
            tableRequest.useDatabaseView = true
            tableRequest.supplier_contract_id = this.header.data.supplier_contract
            tableRequest.noCommit = true
            tableRequest.sortColumn = 'id'
            tableRequest.sortDirection = 'desc'
            
            this.$store.dispatch("PAConservancyController/getEntryHeader", tableRequest)
            .then(response => {
                if ( response.items[0] ) {
                    this.$store.dispatch("PAConservancyController/getEntryHeaderID", response.items[0]['id'])
                    .then(response => {
                        this.tableItems = response.po_items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => { })
                } else {
                    resolve(response);
                }
            })
            .catch(err => {
                if (err.response.data.error && err.response.data.error.message) {
                    this.$alertNotification(err.response.data.error.message, "danger")
                }
            })
        },
        async deleteItems(callback){
            /**/
        },
        async openModalItem(item){
            if(item){
                this.modal.title = 'Edit Item'
                this.modal.data = Object.assign(this.modal.data, item)
            } else {
                this.modal.title = 'Create Item'
                this.modal.data = {
                    contract_id: null,
                    location: null,
                    contract_sum: null
                }
            }
            this.modal.open = true;
        },
        searchContract() {
            /**/
        },
        saveItem() {
            /**/
        },
        async getSupplierContract(search = null) {
            this.loading = true
            let tableRequest = {
                filter: {
                    contract_title: { type: "text", value: search, function: "ilike", with: [] },
                    contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : ''
                },
                limit: 100,
                page: 1,
                isCMS: 1,
                useDatabaseView: true,
                sortColumn: "contract_title",
                sortDirection: "ASC"
            }
            await this.$store.dispatch("ContractController/getListSContracts", tableRequest)
            .then(response => {
                this.header.options.supplier_contracts = response.data.data.contracts

                if(search === null) {
                    this.header.data.supplier_contract = null
                    if(response.data.data.contracts[0].id){
                        this.header.data.supplier_contract = response.data.data.contracts[0].id
                    }
                }
                
                this.loading = false
            })
            .catch(err => {
                this.loading = false
            })
        },
        async searchSupplierContract(search, loading){
            loading(true);
            if(this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(async () => {
                try {
                    await this.getSupplierContract(search);
                    await loading(false);
                } catch (err) {
                    loading(false);
                }
            }, 500);
        },
        async getMaintenanceType(search=null) {

            if(!this.header.data.supplier_contract){
                return false;
            }
            
            this.loading = true

            let tableRequest = {
                filter: {
                    search: search,
                    description_one: null,
                    is_maintenance: true,
                    is_master: false,
                    report_type: 'PO',
                },
                limit: 100,
                page: 1,
                isCMS: false,
                supplier_contract_id: this.header.data.supplier_contract,
                noCommit: true
            }
            await this.$store.dispatch("v2SorController/getItems", tableRequest)
            .then(response => {
                this.header.options.maintenance_ids = response.items
                this.loading = false
            })
            .catch(err => { this.loading = false })
        },
        async searchMaintenanceType(search, loading) {
            loading(true)
            this.header.options.maintenance_ids = []
            if (this.timer.maint) {
                clearTimeout(this.timer.maint);
                this.timer.maint = null;
            }
            this.timer.maint = setTimeout(async () => {
                try {
                    await this.getMaintenanceType(search);
                    await loading(false)
                } catch(e) {
                    loading(false)
                }
            }, 500);
        },
        getInitData(){
            this.loadingData = true;
            var iYear = parseInt(moment().format('YYYY'));
            if(this.Year) this.year = this.Year;
            else this.year = iYear;
            
            for(var i=0;i<15;i++){
                this.years.push(iYear);
                iYear--;
            }
            this.month = moment().format('MM');
            this.populateMonthHeaders();
        },
        populateMonthHeaders(){
            var mTime = moment(this.year+"-"+"January"+"-"+"01","YYYY-MMMM-DD");
            var iMonth = 0;
            var iMonths = [];
            while(iMonth<12){
                var dTime = mTime.clone();
                dTime.add(iMonth,'month');
                iMonths.push({'text' : dTime.format('MMMM'), 'value' : dTime.format('MM')});
                iMonth++;
            }
            this.months = iMonths;
        },
        previewEntry() {
            
            if ( !this.header.data.supplier_contract ) {
                this.$alertNotification("Please select a Supplier Contract", "danger");
                return false;
            }
            if ( !this.header.data.maintenance_id ) {
                this.$alertNotification("Please select a Maintenance Type", "danger");
                return false;
            }

            this.loading = true

            let dataPreview = {
                type: 'po',
                month: this.month,
                year: this.year,
                contract_id: this.header.data.supplier_contract,
                maintenance_id: this.header.data.maintenance_id.id,
            }
            this.$store.dispatch("PAConservancyController/getItems", dataPreview)
            .then(response => {
                this.tableItems = response.items
                this.itemsPreview = JSON.stringify( response.items )
                
                if ( response.total !== 0 ) {
                    this.activeSaveBtn = true
                }

                this.loading = false
            })
            .catch(err => {
                if (err.response.data.error && err.response.data.error.message) {
                    this.$alertNotification(err.response.data.error.message, "danger")
                }
                this.loading = false
            })

            
        },
        saveEntry() {
            if ( !this.itemsPreview ) {
                this.$alertNotification("Empty data item", "danger");
                return false;
            }

            if ( this.activeSaveBtn != true ) {
                return false;
            }

            this.loading = true

            let dataPreview = {
                type: 'po',
                month: this.month,
                year: this.year,
                contract_id: this.header.data.supplier_contract,
                maintenance_id: this.header.data.maintenance_id.id,
                items: this.itemsPreview
            }
            this.$store.dispatch("PAConservancyController/createEntryHeader", dataPreview)
            .then(response => {
                this.$alertNotification("Successfully updated data entry PO", "success");
                this.loading = false
            })
            .catch(err => {
                if (err.response.data.error && err.response.data.error.message) {
                    this.$alertNotification(err.response.data.error.message, "danger")
                }
                this.loading = false
            })
        }
    }
}
</script>